import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExtrasService {

  private productId = new BehaviorSubject(0);
  productId$ = this.productId.asObservable();

  private productName = new BehaviorSubject('');
  productName$ = this.productName.asObservable();

  constructor(private http: HttpClient) { }

  updateProductId(id: number) {
    this.productId.next(id);
  }

  get getProductId() {
    return this.productId.value;
  }

  updateProductName(name: string) {
    this.productName.next(name);
  }

  get getProductName() {
    return this.productName.value;
  }

  getExtrasByStoreId(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/categories-extra?storeId=${id}`, httpOptions);
  }

  getProductExtrasById(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/categories-extra/products/${id}`, httpOptions);
  }

  updateExtra(id, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/products-extra/${id}/status`, status, httpOptions);
  }
}
